export default function getOffers(fixedPrecentage,productUnitPricePrice,fixedAmount){
    let precentage=fixedPrecentage/100
    let finalPrecentage=productUnitPricePrice*precentage
    let fnalAmmount=finalPrecentage+fixedAmount
    let finalOffer=productUnitPricePrice-fnalAmmount
    return  finalOffer
  }